import { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import EditNoteIcon from '@mui/icons-material/EditNote';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import ArticleIcon from '@mui/icons-material/Article';
import TitleBar from '../components/uiParts/TitleBar';
import MenuIcon from '../components/uiParts/MenuIcon';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import PrintIcon from '@mui/icons-material/Print';
import FolderIcon from '@mui/icons-material/Folder';
import { useAuth } from '../contexts/AuthContext';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Box} from '@mui/material';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import DateOutlinedInput from '../components/input/DateOutlinedInput';
import { usePost } from './../apis/ApiRequests';
import CustomSnackBar from '../components/alert/CustomSnackBar';
import { dateToString } from '../utils/Library';
import MonitorIcon from '@mui/icons-material/Monitor';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CustomSelect from '../components/select/CustomSelect';
import { exportList, exportTraderList, slipPrintList } from '../Store';
import Encoding from 'encoding-japanese';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';

const Home = () => {
    
    const navigate = useNavigate();
    
	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo } = useAuth();
    const facilityCode   = authInfo.facilityCode;
    const facilityName   = authInfo.facilityName;
    const userId         = authInfo.userId;
    const userName       = authInfo.userName;
    const traderCode     = authInfo.traderCode
    const trader         = authInfo.trader
    const lobinAuthority = authInfo.authority;
    const today          = authInfo.targetDate;

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ openCsvExport,            setOpenDialogCsvExport      ] = useState(false);
    const [ openDialogSlipPrint,      setOpenDialogSlipPrint      ] = useState(false);
    const [ openDialogBidReportPrint, setOpenDialogBidReportPrint ] = useState(false);
    const [ openCsvDownload,          setOpenDialogCsvDownload    ] = useState(false);
    const [ targetDate_1,             setTargetDate_1             ] = useState(today);
    const [ targetDate_2,             setTargetDate_2             ] = useState(today);
    const [ exportTarget,             setExportTarget             ] = useState(0);
    const [ openSnackBarTrue,         setOpenSnackBarTrue         ] = useState(false);
    const [ shipList,                 setShipList                 ] = useState([]);
    const [ targetShip,               setTargetShip               ] = useState(99999999);
    const [ slipPrint,                setSlipPrint                ] = useState(0);
    const [ slipList,                 setSlipList                 ] = useState([]);
    const [ targetSlip,               setTargetSlip               ] = useState(99999999);
    const [ traderList,               setTraderList               ] = useState([]);
    const [ targetTrader,             setTargetTrader             ] = useState(99999999);

    // 登録データ
    const [registerData, setRegisterData] = useState({
        csvDowload_targetDate_from : today,
        csvDowload_targetDate_to : today,
    });
    //-----------------------------------------------
    // initialize - useRef
    //-----------------------------------------------
    const effectRan     = useRef(false);

    //===============================================
    // API
    //===============================================
	//-----------------------------------------------
    // API - getDataByShipList / BidList
	//-----------------------------------------------
    const { response : getDataByShipList_res, post : getDataByShipList_post } = usePost();
    const getDataByShipList = async () => {
        const numericDate = dateToString(targetDate_2);
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getDataByShipList',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate,
        }
        await getDataByShipList_post(postData);
    };
	//-----------------------------------------------
    // API - getDataByTraderList / BidGroup
	//-----------------------------------------------
    const { response : getDataByTraderList_res, post : getDataByTraderList_post } = usePost();
    const getDataByTraderList = async () => {
        const numericDate = dateToString(targetDate_2);
        const postData = {
            'className'    : 'mch.models.table.BidGroup',
            'methodName'   : 'getDataByTraderList',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate,
        }
        await getDataByTraderList_post(postData);
    };
	//-----------------------------------------------
    // API - exportData / file_transfer
	//-----------------------------------------------
    const { response : exportData_res, post : exportData_post } = usePost();
    const exportData = async () => {
        const target  = Number(exportTarget)
        const targetDate = dateToString(targetDate_1);
        let methodName = '';
        if (target === 0) {
            methodName = 'exportStanSystemxMizuage';
        } else if (target === 1) {
            methodName = 'exportStanSystemxNiuke';
        } else if (target === 2) {
            methodName = 'exportStanSystemxUriage';
        } else if (target === 3) {
            methodName = 'exportOfficeData';
        } else if (target === 4) {
            methodName = 'exportTraderData';
        }
        const postData = {
            'className'   : 'mch.models.file.Transfer',
            'methodName'  : methodName,
            'facilityCode': facilityCode,
            'userId'      : userId,
            'targetDate'  : targetDate,
            'exportTarget': exportTarget,
        };
        await exportData_post(postData);
    };
	//-----------------------------------------------
    // API - setDataByPurchaseList / request_Print
	//-----------------------------------------------
    const { response : setDataByPurchaseList_res, post : setDataByPurchaseList_post } = usePost();
    const setDataByPurchaseList = async () => {
        const numericDate = dateToString(targetDate_2);
        const postData = {
            'className'    : 'mch.models.request.Print',
            'methodName'   : 'setDataByPurchaseList',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'targetDate'   : numericDate,
            'printProc'    : 'purchaseList',
            'senmeiCode'   : targetSlip,
        }
        await setDataByPurchaseList_post(postData);
    };
	//-----------------------------------------------
    // API - setDataByBidReport / request_Print
	//-----------------------------------------------
    const { response : setDataByBidReport_res, post : setDataByBidReport_post } = usePost();
    const setDataByBidReport = async () => {
        const numericDate = dateToString(targetDate_2);
        const postData = {
            'className'    : 'mch.models.request.Print',
            'methodName'   : 'setDataByBidReport',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'targetDate'   : numericDate,
            'printProc'    : 'bidReport',
            'senmeiCode'   : targetShip,
            'traderCode'   : targetTrader,
        }
        await setDataByBidReport_post(postData);
    };
	//-----------------------------------------------
    // API - setDataByDeliveryList / request_Print
	//-----------------------------------------------
    const { response : setDataByDeliveryList_res, post : setDataByDeliveryList_post } = usePost();
    const setDataByDeliveryList = async () => {
        const numericDate = dateToString(targetDate_2);
        const postData = {
            'className'    : 'mch.models.request.Print',
            'methodName'   : 'setDataByDeliveryList',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'targetDate'   : numericDate,
            'printProc'    : 'deliveryList',
            'traderCode'   : targetSlip,
        }
        await setDataByDeliveryList_post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
    //-----------------------------------------------
    // useEffect - ロード時の設定
    //-----------------------------------------------
    useEffect(() => {
        // 初回マウント時のみ実行
        if (effectRan.current === false) {
            effectRan.current = true;
    
            getDataByShipList();
            getDataByTraderList();
        }
    },[]);
    //-----------------------------------------------
    // useLayoutEffect - iPad Safari 初回レンダリング対策
    // 描画前に同期実行されるため、ブラウザは ready=true の状態のみを描画する
    //-----------------------------------------------
    const [ready, setReady] = useState(false);
    useLayoutEffect(() => {
        setReady(true);
    }, []);
    //-----------------------------------------------
    // useEffect - APIレスポンス(getDataByShipList / table_BidList)
    //-----------------------------------------------
    useEffect(() => {
        setShipList([]);
        if (getDataByShipList_res) {
            setShipList(getDataByShipList_res.Data);
        }
    }, [getDataByShipList_res]);
    //-----------------------------------------------
    // useEffect - APIレスポンス(getDataByTraderList_res / table_BidGroup)
    //-----------------------------------------------
    useEffect(() => {
        setTraderList([]);
        if (getDataByTraderList_res) {
            setTraderList(getDataByTraderList_res.Data);
        }
    }, [getDataByTraderList_res]);
	//-----------------------------------------------
    // useEffect - setDataByPurchaseList / request_Print
	//-----------------------------------------------
    useEffect(() => {
        if (setDataByPurchaseList_res) {
            handleClickSnackBarTrue();
        }
    }, [setDataByPurchaseList_res]);
	//-----------------------------------------------
    // useEffect - setDataByBidReport / request_Print
	//-----------------------------------------------
    useEffect(() => {
        if (setDataByBidReport_res) {
            handleClickSnackBarTrue();
        }
    }, [setDataByBidReport_res]);
	//-----------------------------------------------
    // useEffect - setDataByDeliveryList / request_Print
	//-----------------------------------------------
    useEffect(() => {
        if (setDataByDeliveryList_res) {
            handleClickSnackBarTrue();
        }
    }, [setDataByDeliveryList_res]);
	//-----------------------------------------------
    // useEffect - exportData / file_transfer
	//-----------------------------------------------
    useEffect(() => {
        if (exportData_res) {
            let textData = exportData_res.text; // API応答からテキストデータを抽出

            // 改行コードを \r\n に統一（Windows形式）
            textData = textData.replace(/\r?\n/g, '\r\n')

            // Shift_JIS（SJIS）エンコード
            const unicodeArray = Encoding.stringToCode(textData)
            const sjisArray = Encoding.convert(unicodeArray, {
                to: 'SJIS',
                from: 'UNICODE',
                type: 'array',
            })

            const sjisBlob = new Blob([new Uint8Array(sjisArray)], {
                type: 'text/csv',
            })
            const numericDate = dateToString(targetDate_1);
            const blobUrl = URL.createObjectURL(sjisBlob)
            const hiddenElement = document.createElement('a')
            hiddenElement.href = blobUrl
            hiddenElement.target = '_blank'
            const fileNames = ['水揚情報.csv', '荷受情報.csv', '共同売上情報.csv', 'OFFICEDATA.csv', 'TRADERDATA.csv'];
            hiddenElement.download = `${numericDate}_${fileNames[exportTarget]}`;
            hiddenElement.click();
            
            handleClickSnackBarTrue();
        }
    }, [exportData_res]);
	//-----------------------------------------------
    // useEffect - 船名マスタの再取得時
	//-----------------------------------------------
    useEffect(() => {
        if (slipPrint) {
            setSlipList(traderList);
        } else {
            setSlipList(shipList);
        }
    }, [slipPrint]);
	//-----------------------------------------------
    // useEffect - 船名マスタの再取得時
	//-----------------------------------------------
    useEffect(() => {
        if (shipList) {
            if (slipPrint) {
            } else {
                setSlipList(shipList);
            }
        }
    }, [shipList]);
	//-----------------------------------------------
    // useEffect - 仲買人マスタの再取得時
	//-----------------------------------------------
    useEffect(() => {
        if (traderList) {
            if (slipPrint) {
                setSlipList(traderList);
            }
        }
    }, [traderList]);
	//-----------------------------------------------
    // useEffect - 明細・入札結果の日付変更でリストを再取得
	//-----------------------------------------------
    useEffect(() => {
        if (targetDate_2) {
            getDataByShipList();
            getDataByTraderList();
        }
    }, [targetDate_2]);
    
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
    };
	//-----------------------------------------------
    // eventHandler - 画面遷移
	//-----------------------------------------------
    const handleClick = (url) => {
        navigate(url);
    };
	//-----------------------------------------------
    // eventHandler - データの設定
	//-----------------------------------------------
    const handleChange = (name, value) => {
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            [name]: value,
        }));
    };
	//-----------------------------------------------
    // eventHandler - 販売管理CSVの出力対象を変更
	//-----------------------------------------------
    const handleChange_exportTarget = (value) => {
        setExportTarget(value);
    };
	//-----------------------------------------------
    // eventHandler - 販売管理CSVのダウンロード
	//-----------------------------------------------
    const handleClick_csvDownload_execute = () => {
        exportData();
        handleClick_dialogCsvDownload_close(false);
    };
	//-----------------------------------------------
    // eventHandler - 販売管理CSVのダイアログを非表示
	//-----------------------------------------------
    const handleClick_dialogCsvExort_close = () => {
        setOpenDialogCsvExport(false);
    };
	//-----------------------------------------------
    // eventHandler - 販売管理CSVのダイアログを非表示
	//-----------------------------------------------
    const handleClick_dialogCsvDownload_close = () => {
        setOpenDialogCsvDownload(false);
    };
	//-----------------------------------------------
    // eventHandler - 明細印刷の種別を変更
	//-----------------------------------------------
    const handleChange_slipPrint = (value) => {
        setSlipPrint(value);
        getDataByShipList();
        getDataByTraderList();
    };
	//-----------------------------------------------
    // eventHandler - 明細印刷の出力対象を変更
	//-----------------------------------------------
    const handleChange_slipList = (value) => {
        setTargetSlip(value);
    };
	//-----------------------------------------------
    // eventHandler - 明細印刷の実行
	//-----------------------------------------------
    const handleClick_slipList_execute = () => {
        if (slipPrint) {
            setDataByDeliveryList(); // 納品明細
        } else {
            setDataByPurchaseList(); // 仕入明細
        }
    };
	//-----------------------------------------------
    // eventHandler - 明細印刷ダイアログを非表示
	//-----------------------------------------------
    const handleClick_dialogSlipPrint_close = () => {
        setOpenDialogSlipPrint(false);
    };
	//-----------------------------------------------
    // eventHandler - 入札結果印刷の荷主を変更
	//-----------------------------------------------
    const handleChange_bidReport_Ship = (value) => {
        setTargetShip(value);
    };
	//-----------------------------------------------
    // eventHandler - 入札結果印刷の仲買人を変更
	//-----------------------------------------------
    const handleChange_bidReport_Trader = (value) => {
        setTargetTrader(value);
    };
	//-----------------------------------------------
    // eventHandler - 入札結果印刷の印刷
	//-----------------------------------------------
    const handleClick_bidReport_execute = () => {
        setDataByBidReport();
    };
	//-----------------------------------------------
    // eventHandler - 入札結果印刷ダイアログを非表示
	//-----------------------------------------------
    const handleClick_dialogBidReportPrint_close = () => {
	    setOpenDialogBidReportPrint(false);
    };
	//===============================================
	// UI Message
	//===============================================
	// スナックバー(正常)を表示
    const handleClickSnackBarTrue = () => { setOpenSnackBarTrue(true); }
	// スナックバー(正常)を閉じる
    const handleCloseSnackBarTrue = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarTrue(false);
    };
    const handleClick_csvDownload = () => {
        setOpenDialogCsvDownload(true);setExportTarget(4);
    }
    //===============================================
    // Css
    //===============================================
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'460px', color:'#fff', backgroundColor:'#808080'
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    if (!ready) return null;
    return (
        <>
        <Header loginInfo="on" backButton="off" backPage="/" setEntryDate={handleChange_entryDate} />
            <div className='menu' style={{paddingTop:'2px', paddingLeft:'10px', paddingRight:'10px', paddingBottom:'10px'}}>
                { lobinAuthority == 1 || lobinAuthority == 2 ? 
                <div>
                    <TitleBar title="入札メニュー" />
                    <MenuIcon header="Bid Menu" title="荷受け" onClick={() => handleClick('/bidList')}>
                        <EditNoteIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Bid Menu" title="入札"  onClick={() => handleClick('/bidGroup')}>
                        <AccessAlarmIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Bid Menu" title="荷渡し"  onClick={() => handleClick('/deliveryList')}>
                        <ShoppingCartIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Bid Menu" title="入船管理へ"  onClick={() => handleClick('/portHome')}>
                        <DirectionsBoatIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                : <></>
                }
                { lobinAuthority == 3 ? 
                <div>
                    <TitleBar title="一般ユーザメニュー" />
                    {/*
                    <MenuIcon header="Bid Menu" title="水揚情報"  onClick={() => handleClick('/UnloadList')}>
                        <GradeIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    */}
                    <MenuIcon header="Bid Menu" title="入札情報"  onClick={() => handleClick('/bidGroup')}>
                        <AccessAlarmIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Bid Menu" title="入札履歴"  onClick={() => handleClick('/bidHistory')}>
                        <WorkHistoryIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Bid Menu" title="納品データ"  onClick={() => handleClick_csvDownload()}>
                        <CloudDoneIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                : <></>
                }
                { lobinAuthority != 3 ? 
                <div>
                    <TitleBar title="事務所メニュー" />
                    <MenuIcon header="Office Menu" title="荷受けデータ補正"  onClick={() => handleClick('/unloadDataList')}>
                        <ArticleIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Office Menu" title="入札データ補正"  onClick={() => handleClick('/bidDataList')}>
                        <ArticleIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Office Menu" title="明細印刷"  onClick={() => setOpenDialogSlipPrint(true)}>
                        <PrintIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Office Menu" title="入札結果印刷"  onClick={() => setOpenDialogBidReportPrint(true)}>
                        <PrintIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                : <></>
                }
                { lobinAuthority == 1 ? 
                <div>
                    <TitleBar title="管理メニュー" />
                    <MenuIcon header="Management Menu" title="販売管理CSV作成"  onClick={() => setOpenDialogCsvExport(true)}>
                        <CloudDoneIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Office Menu" title="サイネージ"  onClick={() => handleClick('/signageMenu')}>
                        <MonitorIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Management Menu" title="システムマスタ"  onClick={() => handleClick('/systemMastaMenu')}>
                        <FolderIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Management Menu" title="入札マスタ"  onClick={() => handleClick('/bidMastaMenu')}>
                        <FolderIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                : <></>
                }
                <div className='csvExport_dialog'>
                    <Dialog open={ openCsvExport } onClose={ handleClick_dialogCsvExort_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="販売管理CSV作成" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'auto'}}>
                            <div style={{backgroundColor:'#efefef', padding:'10px'}}>
                                <div style={{display:'flex', marginRight:'10px',marginTop:'15px'}}>
                                    <div>
                                        <DateOutlinedInput 
                                            id       = "csvExport_dialog" 
                                            label    = "対象日" 
                                            value    = { targetDate_1 } 
                                            onChange = { (e) => setTargetDate_1(e.target.value) }
                                        />
                                    </div>
                                    <div style={{marginLeft:'10px'}}>
                                        <CustomSelect
                                            id         = "csvExport_target"
                                            label      = "出力対象"
                                            width      = {'255px'}
                                            dataList   = {exportList} 
                                            selectedId = {exportTarget}
                                            onChange   = {(e) => handleChange_exportTarget(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{marginTop:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        size      = "large"
                                        variant   = "contained"
                                        sx        = {{marginLeft:'0px', color:'#fff', width:'440px'}}
                                        onClick   = { () => handleClick_csvDownload_execute() }
                                        startIcon = {<DownloadForOfflineIcon />}
                                    >{'ダウンロード'}
                                    </Button>
                                </div>
                            </div>
                            <div style={{marginTop:'40px',marginLeft:'0px'}}>
                                <Button
                                    color     = "tertiary"
                                    size      = "large"
                                    variant   = "contained"
                                    sx        = { dialog_button_close }
                                    onClick   = {() => handleClick_dialogCsvExort_close()}
                                    startIcon = {<CloseIcon />}
                                >{'閉じる'}
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>
                </div>
                <div className='csvDownload_dialog'>
                    <Dialog open={ openCsvDownload } onClose={ handleClick_dialogCsvDownload_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="納品データダウンロード" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'auto'}}>
                            <div style={{backgroundColor:'#efefef', padding:'10px'}}>
                                <div style={{display:'flex', marginRight:'10px',marginTop:'15px'}}>
                                    <Box display="flex" gap={2}>
                                        <DateOutlinedInput 
                                            id       = "csvExport_dialog" 
                                            label    = "開始日" 
                                            value    = { registerData.csvDowload_targetDate_from } 
                                            onChange = { (e) => handleChange('csvDowload_targetDate_from', e.target.value) }
                                        />
                                        <div style={{marginTop:'5px'}}>～</div>
                                        <DateOutlinedInput 
                                            id       = "csvExport_dialog" 
                                            label    = "終了日" 
                                            value    = { registerData.csvDowload_targetDate_to } 
                                            onChange = { (e) => handleChange('csvDowload_targetDate_to', e.target.value) }
                                        />
                                    </Box>
                                </div>
                                <div style={{marginTop:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        size      = "large"
                                        variant   = "contained"
                                        sx        = {{marginLeft:'0px', color:'#fff', width:'440px'}}
                                        onClick   = { () => handleClick_csvDownload_execute() }
                                        startIcon = {<DownloadForOfflineIcon />}
                                    >{'ダウンロード'}
                                    </Button>
                                </div>
                            </div>
                            <div style={{marginTop:'40px',marginLeft:'0px'}}>
                                <Button
                                    color     = "tertiary"
                                    size      = "large"
                                    variant   = "contained"
                                    sx        = { dialog_button_close }
                                    onClick   = {() => handleClick_dialogCsvDownload_close()}
                                    startIcon = {<CloseIcon />}
                                >{'閉じる'}
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>
                </div>
                <div className='slipList_dialog'>
                    <Dialog open={ openDialogSlipPrint } onClose={ handleClick_dialogSlipPrint_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="明細の印刷" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'auto'}}>
                            <div style={{backgroundColor:'#efefef', padding:'10px'}}>
                                <div style={{display:'flex', marginRight:'10px',marginTop:'15px'}}>
                                    <div>
                                        <DateOutlinedInput 
                                            id       = "csvExport_dialog" 
                                            label    = "対象日" 
                                            value    = { targetDate_2 } 
                                            onChange = { (e) => setTargetDate_2(e.target.value) }
                                        />
                                    </div>
                                    <div style={{marginLeft:'10px'}}>
                                        <CustomSelect
                                            id         = "csvExport_target"
                                            label      = "出力明細"
                                            width      = {'255px'}
                                            dataList   = {slipPrintList} 
                                            selectedId = {slipPrint}
                                            onChange   = {(e) => handleChange_slipPrint(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{display:'flex', marginLeft:'170px',marginTop:'15px'}}>
                                    <div style={{marginLeft:'10px'}}>
                                        <CustomSelect
                                            id         = "csvExport_target"
                                            label      = "印刷対象"
                                            width      = {'255px'}
                                            dataList   = {slipList} 
                                            selectedId = {targetSlip}
                                            onChange   = {(e) => handleChange_slipList(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{marginTop:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        size      = "large"
                                        variant   = "contained"
                                        sx        = {{marginLeft:'0px', color:'#fff', width:'440px'}}
                                        onClick   = { () => handleClick_slipList_execute() }
                                        startIcon = {<PrintIcon />}
                                    >{'印刷'}
                                    </Button>
                                </div>
                            </div>
                            <div style={{marginTop:'40px',marginLeft:'0px'}}>
                                <Button
                                    color     = "tertiary"
                                    size      = "large"
                                    variant   = "contained"
                                    sx        = { dialog_button_close }
                                    onClick   = {() => handleClick_dialogSlipPrint_close()}
                                    startIcon = {<CloseIcon />}
                                >{'閉じる'}
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>
                </div>
                <div className='bidReport_dialog'>
                    <Dialog open={ openDialogBidReportPrint } onClose={ handleClick_dialogBidReportPrint_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="入札結果の印刷" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'auto'}}>
                            <div style={{backgroundColor:'#efefef', padding:'10px'}}>
                                <div style={{display:'flex', marginRight:'10px',marginTop:'15px'}}>
                                    <div>
                                        <DateOutlinedInput 
                                            id       = "bidReport_dialog" 
                                            label    = "対象日" 
                                            value    = { targetDate_2 }
                                            onChange = { (e) => setTargetDate_2(e.target.value) }
                                        />
                                    </div>
                                    <div style={{marginLeft:'10px'}}>
                                        <CustomSelect
                                            id         = "bidReport_Ship"
                                            label      = "対象荷主"
                                            width      = {'255px'}
                                            dataList   = {shipList}
                                            selectedId = {targetShip}
                                            onChange   = {(e) => handleChange_bidReport_Ship(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{display:'flex', marginRight:'10px',marginTop:'15px'}}>
                                    <div style={{marginLeft:'178px'}}>
                                        <CustomSelect
                                            id         = "bidReport_Trader"
                                            label      = "対象仲買人"
                                            width      = {'255px'}
                                            dataList   = {traderList}
                                            selectedId = {targetTrader}
                                            onChange   = {(e) => handleChange_bidReport_Trader(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{marginTop:'10px'}}>
                                    <Button
                                        color     = "secondary"
                                        size      = "large"
                                        variant   = "contained"
                                        sx        = {{marginLeft:'0px', color:'#fff', width:'440px'}}
                                        onClick   = { () => handleClick_bidReport_execute() }
                                        startIcon = {<PrintIcon />}
                                    >{'印刷'}
                                    </Button>
                                </div>
                            </div>
                            <div style={{marginTop:'40px',marginLeft:'0px'}}>
                                <Button
                                    color     = "tertiary"
                                    size      = "large"
                                    variant   = "contained"
                                    sx        = { dialog_button_close }
                                    onClick   = {() => handleClick_dialogBidReportPrint_close()}
                                    startIcon = {<CloseIcon />}
                                >{'閉じる'}
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>
                </div>
                <CustomSnackBar
                    open            = {openSnackBarTrue}
                    onClose         = {() => handleCloseSnackBarTrue()}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "実行しました"
                />
            </div>
        </>
    )
}
export default Home;